module.exports = __webpack_public_path__ + "img/rang7.63f428e9.png";